export default __webpack_public_path__ + "static/media/spectrophotometer-info-8.ede62f62.svg";